import { app } from '../../app';
import { resolve } from '../../init/store';
import { lazyLoad } from '../../lib/lazy-load';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company', {
        url: '/admin/company/:companyId',
        redirectTo: 'company.landing-page',
        component: 'company',
        resolve: {
            $breadcrumbs,
            account,
            appCategories$,
            appType$,
            appTypes$,
            appTypesAndCategories$,
            companyId,
            currentCompany,
            prefetch,
            publicServicesWithEPM$,
            licenseInfo,
            requests
        },
    });
}

/** @ngInject */
function $breadcrumbs(currentCompany) {
    return [{title: currentCompany.companyName}];
}

/** @ngInject */
function account(Account) {
    return Account.get();
}

/** @ngInject */
function appCategories$(appTypesAndCategories$) {
    return appTypesAndCategories$.map(({aCs}) => aCs);
}

appType$.byId = {};

/** @ngInject */
function appType$(AddNewApplicationResource, companyId) {
    return appTypeId => appType$.byId[appTypeId] = appType$.byId[appTypeId] ||
        lazyLoad(() => AddNewApplicationResource.getApplicationsType(companyId, appTypeId))
}

/** @ngInject */
function appTypes$($filter, $q, appTypesAndCategories$) {
    return appTypesAndCategories$
        .map(({aTs}) => aTs)
        .map(items => items.filter(item => item.slug !== 'enterprise-password-manager'))
        .map(items => $filter('orderBy')(items, 'applicationTypeDisplayName'))
        .map(items => {
            items.forEach(item => appType$.byId[item.id] = lazyLoad(() => $q.resolve(item)));
            return items;
        })
}

/** @ngInject */
function appTypesAndCategories$(AddNewApplicationResource, companyId) {
    return lazyLoad(() => AddNewApplicationResource.getAllApplicationsTypes(companyId))
}

/** @ngInject */
function companyId($stateParams) {
    return resolve.companyId = $stateParams.companyId;
}

/** @ngInject */
function currentCompany(account, companyId) {
    return resolve.currentCompany = account.userCompanyRoles
        .find(company => company.companyId === companyId)
}

/** @ngInject */
function prefetch(appTypes$, publicServicesWithEPM$) {
    appTypes$.get();
    publicServicesWithEPM$.get();
}

/** @ngInject */
function publicServicesWithEPM$(PublicServiceResource) {
    return lazyLoad(() => PublicServiceResource.getAllWithEpmSupportFiltered())
        .map(items => {
            const custom = items.find(i => i.slug === 'other');
            custom.serviceName = 'Custom Password Manager';
            return items;
        })
}

/** @ngInject */
function licenseInfo(LicenseManagementService, companyId) {
    return LicenseManagementService.licenseCheck(companyId);
}

/** @ngInject */
function requests(AccessRequestsService, $stateParams) {
    return AccessRequestsService.getRequestsForCompany($stateParams.companyId);
}


// WEBPACK FOOTER //
// ./src/portal/states/company/company.state.js